/** Full column box in px, padding included. */
export const FUND_COLUMN_WIDTH = {
  created: 136,
  name: 160,
  amount: 120,
  kind: 96,
  status: 136,
  ref: 128,
  acct: 128,
  method: 128,
  confirmed: 136,
  ib: 128,
} as const

// Decision fields first, so a narrow card (detail panel docked) still shows when and what kind.
const BASE = ['name', 'amount', 'status', 'kind', 'created'] as const

/** Spare px required before a tier is shown, and the deadband on either side of that line. */
const SPARE = 16
const BAND = 8

const TIERS: { sum: number; keys: readonly string[] }[] = [
  { sum: 904, keys: ['acct', 'ref'] },
  { sum: 1168, keys: ['method', 'confirmed'] },
  { sum: 1296, keys: ['ib'] },
]

/** Which fund columns fit. A tier is added only when availablePx >= tierSum + 16. */
export function visibleFundColumnKeys(availablePx: number): string[] {
  const keys: string[] = [...BASE]
  for (const tier of TIERS) {
    if (availablePx >= tier.sum + SPARE) keys.push(...tier.keys)
  }
  return keys
}

/**
 * Keep the tier already shown unless the width is more than 8px past its line.
 * A ~15px scrollbar swing from just above the enter line stays inside the band.
 */
export function fundColumnsForWidth(shown: readonly string[], availablePx: number): string[] {
  const have = new Set(shown)
  const keys: string[] = [...BASE]
  for (const tier of TIERS) {
    const on = tier.keys.every((key) => have.has(key))
    const line = tier.sum + SPARE
    const keep = on ? availablePx >= line - BAND : availablePx > line + BAND
    if (keep) keys.push(...tier.keys)
  }
  return keys
}
